import { useMenu } from "@/features/navigation/MenuContext";
import { createContext, useContext } from "react";

/**
 * Whether the stack surface this subtree renders in is the top of the stack.
 * The base surface (tab panes, pages) is covered whenever a stack overlay or
 * the navigation drawer is open;
 * outside the signed-in shell and stacked router nothing is covered.
 *
 * A covered surface stays mounted, so anything with side effects the user can
 * perceive while it is hidden — video audio, a live map's GPU memory — must
 * read this rather than rely on unmount.
 */
export const StackSurfaceContext = createContext<{ isTop: boolean }>({ isTop: true });

export const useStackSurfaceCovered = (): boolean => {
  const surface = useContext(StackSurfaceContext);
  const menu = useMenu();
  return !surface.isTop || menu?.open === true;
};
